import moment from 'moment';
import Assignment from "./assignment";


 


        class Campaign{
         constructor(params,o){
          this.id = o.id;
          this.accountType = "Campaign";
          
            this._types = {
              "assignment":Assignment
            }
            this.generic = {
              name:"",
              id:"",
              platformId:"",
              description:"",
              subTitle:"",
            }
               
            this.setParameters(o);
               

            for (var t of Object.keys(this._types)){
             if (params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
               for (var pt of params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
                 if (pt.objectIds.indexOf(this.id) > -1){
                   for (var oid of pt.pivotObjectIds){
                     if ((params.accounts[pt.pivotAccountId] && params.accounts[pt.pivotAccountId][oid]) && (!this.filter || (this.filter && this.filter[pt.pivotAccountId] && this.filter[pt.pivotAccountId].indexOf(oid) > -1))) {
                      
                       params.accounts[pt.pivotAccountId][oid].filter = (this.filter) ? this.filter : false;
                       params.accounts[pt.pivotAccountId][oid].truncate = (this.truncate) ? this.truncate : false;
                       var acs = params.accounts[pt.pivotAccountId][oid];
                       acs.originId = pt.originId;
                       acs.originAccountId = pt.originAccountId;
                       
                   var model = new this._types[t](params,acs);
                   
                    this.setModelParameters(model);
                   
                     
                     }
                   }
                 }
             }
           }
           }
         
           
   }



             setParameters(params){
               for (var prop in params){
                   if (params.hasOwnProperty(prop)){
                       var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
                       if (this[method]){
                         this[method](params[prop]);
                       }
                       
                   }
               }

           }

         
             
           setId(id){
               this.id = id;
               this.generic.id = id;
         }

         setCampaignName(str){
          this.generic.name = str;
          this.generic.label = str;
         }


         
         setPlatformId(id){
          this.platformId = id;
          this.generic.platformId = id;
          this.generic.subTitle = id;
        }



        setTruncate(obj){
          if (obj){
            var tr = {};
            Object.keys(obj).map((o) => {
                var nk = (o == 21) ? "Campaign" : o;
                tr[nk] = obj[o];
            })
          this.truncate = tr;
          this.filtered = (tr && tr[this.accountType] && (tr[this.accountType].indexOf(this.id) > -1)) ? false : true;
          }
        }
           

           
        setUrls(str){
          this.urls = str;
        }
        setOriginAccountId(id){
          this.originAccountId = id;
          this.generic.originAccountId = id;
        }
        setOriginId(id){
          this.originId = id;
          this.generic.originId = id;
        }
         
       
       setModelParameters(params){
        if (params.accountType == "Assignment"){
            if (params.parentProperty){
              this.variables = (this.variables) ? this.variables : [];
              var vo = {value:params.parentValue,label:params.parentProperty,variables:(params.variables) ? params.variables : []};
this.variables.push(vo);
            }
        }else{
           this[params.accountType] = (this[params.accountType]) ? this[params.accountType] : [];
           this[params.accountType].push(params);
        }
       }
     }
export default Campaign;
        